export default __webpack_public_path__ + "1aab6869470bef7111016608e3152dc7.ico";